import settings from './models/settings';
import sureBetCalculator from './models/sureBetCalculator';
import arbsPage from './models/arbsPage';
import valueBetsPage from './models/valueBetsPage';
import apiPage from './models/apiPage';

export default {
  settingsRequests: settings,
  sureBetCalculatorRequests: sureBetCalculator,
  arbsPageRequests: arbsPage,
  valueBetsPageRequests: valueBetsPage,
  apiPageRequests: apiPage,
};
